export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13297.1244ef32.jpg";